import React, { useEffect } from "react";
import { motion } from "framer-motion";

export const KebijakanPrivasi = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full min-h-screen py-20 text-center text-lime-600 flex-col justify-center relative bg-white">
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-2xl font-black uppercase tracking-wider text-lime-600"
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          PT CAKRAWALA JAKARTA KREATIF
        </motion.h2>
        <motion.h3
          className="text-3xl md:text-5xl font-black text-lime-600 mb-8 mt-2"
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
        >
          PRIVACY POLICY
        </motion.h3>

        <div className="max-w-5xl mx-auto space-y-4">
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-xl px-4 py-6 border border-slate-200">
              <h3 className="text-xl font-bold text-slate-600 mb-4">
                Privacy Policy
              </h3>
              <div className="text-md text-slate-600 space-y-6">
                <p>
                  PT Cakrawala Jakarta Kreatif acts as the controller of your
                  personal data and respects the privacy of every user. This
                  Privacy Policy explains how we collect, use, and protect the
                  personal information you provide.
                </p>

               <p>
  By accessing and using the site{" "}
  <a
    href="https://cakrawalajakarta.id"
    target="_blank"
    rel="noopener noreferrer"
    className="text-lime-600 underline"
  >
    cakrawalajakarta.id
  </a>{" "}
  ,{" "}
  <a
    href="https://jakartaopentrailrun.com"
    target="_blank"
    rel="noopener noreferrer"
    className="text-lime-600 underline"
  >
    jakartaopentrailrun.com
  </a>{" "}
  and all its sub-domains, you are deemed to have read,
  understood, and agreed to the terms listed in this Privacy
  Policy.
</p>


                <h3 className="text-lg font-semibold text-slate-600">
                  Information We Collect
                </h3>
                <p>
                  We collect information automatically when you visit the
                  website, including device data such as browser, IP address,
                  time zone, and cookies. In addition, we collect information
                  that you provide directly, such as name, email address, phone
                  number, and payment information when registering for an event.
                </p>

                <h3 className="text-lg font-semibold text-slate-600">
                  Purpose of Data Collection
                </h3>
                <p>The data we collect is used to:</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Process event registration and payments.</li>
                  <li>Send confirmation and event-related information.</li>
                  <li>Improve website user experience.</li>
                  <li>
                    Deliver updates and information regarding our activities.
                  </li>
                </ul>

                <h3 className="text-lg font-semibold text-slate-600">
                  Your Rights to Personal Data
                </h3>
                <p>
                  If you are in Europe or other jurisdictions that provide
                  rights to personal data, you have the right to access,
                  correct, delete, restrict, or object to data processing, as
                  well as request data portability. Requests can be submitted
                  via our contact below.
                </p>

                <h3 className="text-lg font-semibold text-slate-600">
                  Links to Third-Party Websites
                </h3>
                <p>
                  Our website may contain links to other websites not managed by
                  us. We are not responsible for the privacy policies or
                  practices of such third-party websites.
                </p>

                <h3 className="text-lg font-semibold text-slate-600">
                  Data Security
                </h3>
                <p>
                  We take reasonable technical and administrative measures to
                  protect your personal data from unauthorized access. However,
                  we cannot fully guarantee the security of information
                  transmitted over the internet.
                </p>

                <h3 className="text-lg font-semibold text-slate-600">
                  Information Disclosure
                </h3>
                <p>
                  We may disclose your personal information if required by law,
                  court order, or to protect our rights, safety, and security or
                  those of others.
                </p>

                <h3 className="text-lg font-semibold text-slate-600">Contact</h3>
                <p>
                  For questions regarding this Privacy Policy or the use of your
                  personal data, please contact:
                </p>
                <p>
                  PT Cakrawala Jakarta Kreatif <br />
                  Email:{" "}
                  <a
                    href="mailto:admin@cakrawalajakarta.com"
                    className="text-lime-600 hover:underline"
                  >
                    admin@cakrawalajakarta.com
                  </a>
                  <br />
                  Website:{" "}
                  <a
                    href="https://cakrawalajakarta.id"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-lime-600 hover:underline"
                  >
                    https://cakrawalajakarta.id
                  </a>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
